<template>
	<div class="qyjs_box">

		<div>
			<router-view></router-view>
		</div>
		<div class="box">
			<div class="boxA">
				<div class="box-tit"><span>提前批</span></div>
				<div class="search-t">
					<el-input placeholder="请输入院校名称" v-model="queryParams.schoolName" class="input-with-select" @keyup.enter.native="schGet" @clear="schGet"
						clearable>
						<el-button type="danger" slot="append" icon="el-icon-search" @click="schGet">搜索</el-button>
					</el-input>
				</div>
				<el-form :model="queryParams" ref="queryForm" size="small" :inline="true" class="topsec"
					@submit.native.prevent>
					<el-row :gutter="24" v-if="filtrate.F&&filtrate.F.length">
						<el-col :span="24">
							<el-form-item label="年份:" label-width="80px">
								<div class="kuai">
									<span v-for="item in filtrate.F" :label="item.year" :key="item.year"
										:class="queryParams.year==item.year?'onsele':''"
										@click="clickA(item)">{{ item.year }}</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="28">
						<el-col :span="28">
							<el-form-item label="类型:" label-width="80px">
								<div class="collboxA" v-for="(subCategories, categoryKey) in filtrate.D"
									:key="categoryKey">
									<div class="collboxA-tit">{{categoryKey}}：</div>
									<div class="collboxA-ul" v-for="(items, subCategoryKey) in subCategories">
										<span class=" collboxA-ul-lisan" v-for="item in items" :key="item"
											:class="(queryParams.typeName==item&&queryParams.batchId==subCategoryKey)?'onsele':''"
											@click="tiTypeRadio(item,subCategoryKey)">{{item}}</span>
									</div>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="24">
						<el-col :span="24">
							<el-form-item label="院校类型:" label-width="80px">
								<div class="kuai">
									<span v-for="item in filtrate.A" :label="item" :key="item"
										:class="queryParams.schoolType==item?'onsele':''"
										@click="clickB(item)">{{ item }}</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="28">
						<el-col :span="28">
							<el-form-item label="院校层次:" label-width="80px">
								<div class="kuai">
									<span v-for="item in filtrate.C" :class="queryParams.attribute==item?'onsele':''"
										@click="clickD(item)">{{ item }}</span>
								</div>
							</el-form-item>
						</el-col>
					</el-row>

				</el-form>
			</div>
			<!-- 学校列表 -->
			<div class="schmain">
				
				<div class="sch-ul"  ref="scrollContainer" v-intersect="handleIntersect">
					<!-- @child-event="handleChildEvent" -->
						
					<div class="sch-li" v-for="(item,index) in schList" v-if="(user.userVip==0&&index<=4)||(user.userVip>0)||!token||token">
						<div class="schli-l"><img :src="UPLODE_URL+item.schoolLogo" alt="" /></div>
						<div class="schli-r">
							<div class="schli-r-ll" @click="goInfo(item)">
								<div class="schli-rt">
									<span class="schli-rt-a">{{item.schoolName}}</span>
									<!-- <span class="schli-rt-b">{{item.majorName?item.majorName:'-'}}</span> -->
									<!-- <span class="t-con-2" style="color: #505559;font-size: 12px;margin-left: 10px;" v-if="item.zuoyueJihua!=0||item.oneJihua==1||item.youJihua==1">{{item.oneJihua!=0?'101计划 | ':''}}  {{item.zuoyueJihua==1?'卓越工程师 | ':''}}  {{item.youJihua==1?'国优计划':''}}</span> -->
								</div>
								<div class="schli-rt">
									<span class="schli-rt-b">{{item.majorName?item.majorName:'-'}}</span>
								</div>
								<div class="schli-rb">
									<span class="">代码 {{item.schoolCode?item.schoolCode:'-'}}</span>
									<!-- <span v-if="item.citySchoolName">{{item.citySchoolName}}</span> -->
									<span v-if="item.natureName">{{item.natureName}}</span>
								
									<!-- <span v-if="item.natureName">{{item.natureName}}</span>
								<span v-if="item.schoolType">{{item.schoolType}}</span>
								<span v-if="item.schoolLevel">{{item.schoolLevel}}</span>
								<span v-if="item.attribute">{{item.attribute}}</span>
								<span v-if="item.unit">{{item.unit}}</span>
								<span v-if="item.oneJihua!=0">{{item.oneJihua!=0?'101计划':''}}</span>
								<span v-if="item.zuoyueJihua==1">{{item.zuoyueJihua==1?'卓越工程师':''}}</span>
								<span v-if="item.youJihua==1">{{item.youJihua==1?'国优计划':''}}</span> -->
								</div>
							</div>
							<div class="schli-r-rr"> 
								<table border="1" class="tableclass" >
								    <tr class="tableclass-tra">
								        <th style="font-weight: bold;">专业代码</th>
										<th>分数</th>
								        <th>位次</th>
								        <th>计划</th>
								        <th>学制</th>
										<th>学费</th>
								        <th>选科要求</th>
								    </tr>
								    <tr class="tableclass-trb">
								        <td  style="font-weight: bold;">{{item.majorCode?item.majorCode:'-'}}</td>
								        <td>{{item.branchs?item.branchs:'-'}}</td>
										<td>{{item.rank?item.rank:'-'}}</td>
										<td>{{item.plan?item.plan:'-'}}</td>
										
										<td>{{item.yearEdu?item.yearEdu:'-'}}</td>
										<td>{{item.money?item.money:'-'}}</td>
										<td>{{item.kemu?item.kemu:'-'}}</td>
								    </tr>
								</table>
							</div>
						</div>
					</div>
					<div style="position: relative;  padding: 0px 0 100px 0px; transform: translate(23%, 10%);" v-if="user.userVip==0">
						<nVip  v-if="user.userVip==0" version="旗舰版" name="就业数据"></nVip>
					</div>
				
				</div>
				<div style="min-height: 70vh;" v-if="!token&&!user.score"><el-empty description="请先登录完善信息"></el-empty></div>
				<el-empty v-if="user.userVip==1&&schList.length==0" :image-size="200"></el-empty>
			</div>
		</div>
		<div ref="loadMoreTrigger" style="height: 100px;"></div>

	</div>
</template>

<script>
	import { xuemengintro } from "@/api/intoxuemeng";
	import { EventBus } from '@/utils/event-bus.js';
	import { UPLODE_URL } from '@/utils/request'
	import nVip from '@/components/n-vip.vue';
	export default {
		components: {
			nVip
		},
		data() {
			return {
				UPLODE_URL,
				user: JSON.parse(localStorage.getItem('user')) || '',
				token: localStorage.getItem('token')||'',
				filtrate: {
					A: ['综合', '理工', '财经', '艺术', '农业', '林业', '医药', '师范', '体育', '语言', '政法', '民族', '军事'], //院校类型
					B: ['公办', '民办', '独立学院', '中外合作办学', '内地与港澳台地区合作办学', '境外高校独立办学'], //办学性质
					C: ['985', '211', '研究生院', '双一流', '保研', '双高高职', '示范高职', '骨干高职'], //院校层次
					D: [], //标签
					E: [],
					F: [],
					G: ['是'],
					H: [{
						name: '101计划',
						id: '是',
						quer: 'oneJihuas'
					}, {
						name: '卓越工程师',
						id: '是',
						quer: 'zuoyueJihuas'
					}, {
						name: '国优计划',
						id: '是',
						quer: 'youJihuas'
					}],
					// {name:'武书连',id:'是',quer:'wushulian'},
					J: [{
						name: '软科综合',
						id: '是',
						quer: 'ruanke'
					}, {
						name: '校友会综合',
						id: '是',
						quer: 'xiaoyouhui'
					}, {
						name: 'QS',
						id: '是',
						quer: 'QS'
					}, {
						name: 'US',
						id: '是',
						quer: 'US'
					}],
				},
				schList: [],
				pageTotal: 0,
				busy: true,

				// 查询参数
				queryParams: {
					pageNum: 1,
					pageSize: 20,
					year: '',
					schoolName: '', //学校名
					typeName: '', //类型
					schoolType: '', //院校类型
					attribute: [], //院校层次
					batchId: ''
				},
			};
		},
		directives: {
			intersect: {
				bind(el, binding) {
					const observer = new IntersectionObserver((entries, observer) => {
						console.log('entries', entries)
						entries.forEach(entry => {
							if (entry.isIntersecting) {
								const img = entry.target;
								console.log('2222sdfsfs', img)
								// 在这里可以做图片的懒加载处理，比如更改src属性
								// img.src = img.dataset.src;
								// 或者触发其他的方法
								// binding.value(entry, observer);
								// observer.unobserve(img); // 停止观察
								// this.createObserver();
							}
						});
					});

					observer.observe(el);
				}
			}
		},
		beforeRouteUpdate(){
			console.log('刷新不')
			// this.getTiType()
			// this.createObserver();
		},
		beforeDestroy() {
			  // 移除 storage 事件监听器
			  window.removeEventListener('storage', this.handleStorageEvent);
			  
		  },
		created() {
			// 登录完 确定完 去请求录取接口
			EventBus.$on("callLoginDialog", () => {
				this.token=localStorage.getItem('token')||''
				this.user=JSON.parse(localStorage.getItem('user'))||''
				this.getTiType()
				this.createObserver();
			});
		},
		mounted() {
			this.user = JSON.parse(localStorage.getItem('user')) || ''
			this.user = JSON.parse(localStorage.getItem('user')) || ''
			
			if(!this.token) {
				EventBus.$emit('noopsycheOpen');
				return
			}else if(!this.user.score){
				EventBus.$emit('showModal');
				return
			}
			
			
				this.getTiType()
				this.createObserver();
				
				
			window.addEventListener('storage', this.handleStorageEvent);
		},
		methods: {
			handleStorageEvent(event) {
			      if (event.key == 'token') {
			        // 更新登录状态
						this.token=localStorage.getItem('token')||''
						this.user=JSON.parse(localStorage.getItem('user'))||''
						this.$router.push({path:'/'})
						window.location.reload()
			        // this.checkLoginStatus();
			      }
			    },
			// 获取类型
			getTiType() {
				this.api.appJihuaTiTypeApi().then(res => {
					if (res.code == 200) {
						if (res.data) {
							this.filtrate.D = res.data;

							const categoryKey = "普通类";
							const dynamicKeysAndValues = {}; // 用于存储动态键和值的对象
							for (const subCategoryKey in res.data[categoryKey]) {
								// 假设我们不知道哪个键是动态的，但我们想要存储所有键和值
								dynamicKeysAndValues[subCategoryKey] = res.data[categoryKey][subCategoryKey];
							}
							if (!dynamicKeysAndValues) {
								const categoryKeyDe = "艺术类_美术";
								const dynamicKeysAndValues = {}; // 用于存储动态键和值的对象
								for (const subCategoryKey in res.data[categoryKeyDe]) {
									dynamicKeysAndValues[subCategoryKey] = res.data[categoryKeyDe][subCategoryKey];
								}
							}
							if (dynamicKeysAndValues) {
								for (const key in dynamicKeysAndValues) {
									console.log('dynamicKeysAndValues', dynamicKeysAndValues[key][0])
									console.log('key', key)
									this.queryParams.batchId = key
									// that.qs.typeName = dynamicKeysAndValues[key][0]
								}
							}


							console.log('this.filtrate.D', this.filtrate.D)
						}
						this.getYear()
					}
				})
			},
			//类型选择
			tiTypeRadio(item, batchId) {
				if(!this.token) {
					EventBus.$emit('noopsycheOpen');
					return
				}else if(!this.user.score){
					EventBus.$emit('showModal');
					return
				}
				if(this.user.userVip==0){
					this.$message({
					  message: '开通VIP体验此功能',
					  type: 'warning',
					  duration: '4000'
					});
					return
				}
				

				if (batchId == this.queryParams.batchId) {
					if (this.queryParams.typeName == item) {
						this.queryParams.typeName = ''
					} else {
						this.queryParams.typeName = item
					}
				} else {
					this.queryParams.typeName = ''
					this.queryParams.batchId = batchId
					this.queryParams.typeName = item

				}
				this.queryParams.pageNum = 1
				this.getList()
				// this.qs.batchId = batchId
			},
			getYear() {
				let qu = {
					cityId: this.user.cityId,
					type: 1
				}
				this.api.homeBatchYearTiApi(qu).then(res => {
					if (res.code == 200) {
						this.filtrate.F = res.data
						this.queryParams.year = res.data[0].year
						
						this.getList()
					}
				})
			},



			// 跳转学校详情
			goInfo(item) {
				console.log('item',item)
				// localStorage.setItem('xiaoid',item.schoolId)
				// this.$router.push({path:'/Ainformation/schoolInfo'})
				// return
				
				
				const route = this.$router.resolve({
					name: 'schoolInfo',
				})
				localStorage.setItem('xiaoid', item.schoolId)
				// 打开新窗口并导航至生成的URL
				window.open(route.href, '_blank');
			},
			handleIntersect(entry, observer) {
				console.log('11111111111111111111bbb')
				if (this.queryParams.pageNum >= this.pageTotal) {
					// this.$message({
					//   message: '没有更多了',
					//   type: 'warning',
					//   duration: '4000'
					// });
					return
				}
				// this.busy = true
				if(this.user.userVip==0){
					return
				}
				this.queryParams.pageNum++;
				this.getList('more')
			},
			createObserver() {
				const options = {
					root: null, // viewport
					rootMargin: '100px',
					threshold: 1.0
				};
				const observer = new IntersectionObserver(this.handleIntersect, options);
				observer.observe(this.$refs.loadMoreTrigger);
			},
			
			// 获取筛选省份
			city() {
				this.api.homeCityListApi().then(res => {
					this.filtrate.F = res.data
				})
			},
			// 院校所属 点击
			clickA(item) {
				if(this.user.userVip==0){
					this.$message({
					  message: '开通VIP体验此功能',
					  type: 'warning',
					  duration: '4000'
					});
					return
				}
				this.queryParams.year = item.year
				this.queryParams.pageNum = 1;
				this.getList()
			},
			// 院校类型 点击
			clickB(item) {
				if(!this.token) {
					EventBus.$emit('noopsycheOpen');
					return
				}else if(!this.user.score){
					EventBus.$emit('showModal');
					return
				}
				if(this.user.userVip==0){
					this.$message({
					  message: '开通VIP体验此功能',
					  type: 'warning',
					  duration: '4000'
					});
					return
				}
				if (this.queryParams.schoolType == item) {
					this.queryParams.schoolType = ''
				} else {
					this.queryParams.schoolType = item
				}
				this.queryParams.pageNum = 1;
				this.getList()
			},
			

			// 院校层次 点击
			clickD(item) {
				if(!this.token) {
					EventBus.$emit('noopsycheOpen');
					return
				}else if(!this.user.score){
					EventBus.$emit('showModal');
					return
				}
				if(this.user.userVip==0){
					this.$message({
					  message: '开通VIP体验此功能',
					  type: 'warning',
					  duration: '4000'
					});
					return
				}
				if (this.queryParams.attribute == item) {
					this.queryParams.attribute = ''
				} else {
					this.queryParams.attribute = item
				}
				this.queryParams.pageNum = 1;
				this.getList()
			},

			schGet() {
				
				this.queryParams.pageNum = 1;
				this.getList()
			},
			
			// 数据列表请求
			getList(type) {
				
				let qu = {
					schoolName: this.queryParams.schoolName,
					pageNum: this.queryParams.pageNum,
					pageSize: this.queryParams.pageSize,
					// citySchoolIds:this.qs.citySchoolIds.toString()||'',
					// majorCodeAll:this.qs.majorCodeAll.toString()||'',
					// natureName:this.qs.natureName.toString()||'',//多选
					natureName: this.queryParams.natureName || '', //单选
					attribute: this.queryParams.attribute.toString() || '',
					schoolType: this.queryParams.schoolType || '',
					schoolName: this.queryParams.schoolName || '',
					year: this.queryParams.year,
					cityId: this.user.cityId,
					batchId: this.queryParams.batchId,
					typeName: this.queryParams.typeName || '',
				}


				this.api.appJihuaTiApi(qu).then(res => {
					if (res.code == 200) {

						if (type == 'more') {
							if (!res.data) {
								this.$message({
									message: '没有更多了',
									type: 'warning',
									duration: '4000'
								});
								return
							}
							this.schList = [...this.schList, ...res.data.rows];

						} else {
							this.schList = []
							this.schList = res.data ? res.data.rows : [];
							// this.dataText = res.data ? '' : '暂无数据'; //进去页面先让字样为空
							this.pageTotal = res.data ? res.data.pageTotal : 0;
						}


					} else {
						this.$message.error(res.msg);
						this.schList = []
						this.queryParams.pageNum = 1
						this.pageTotal= 0;
					}
				})
			}
		},
	};
</script>

<style lang="scss" scoped>
	.img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}


	.box {
		/deep/.el-form-item__content {
			flex: 1;
		}

		.el-form-item--small.el-form-item {
			margin-bottom: 5px;
		}

		// height: 100vh;
		// min-height: 30vh;
		.boxA {
			background: #fff;
			border-radius: 10px;
			padding: 10px 20px 20px 20px;
			margin-top: 10px;

			.box-tit {
				width: 100%;
				height: 40px;
				line-height: 40px;
				border-bottom: 1px solid #F44F4D;
				margin-bottom: 15px;

				span {
					width: 140px;
					height: 40px;
					line-height: 40px;
					background-color: #F44F4D;
					color: #fff;
					display: block;
					border-radius: 10px 10px 0 0;
					text-align: center;
					font-size: 15px;
				}
			}

			.search-t {
				width: 30%;
				margin-bottom: 10px;

				.input-with-select {
					border-radius: 4px;

					/deep/.el-input__inner {
						border-color: #F56C6C !important;
					}

					/deep/.el-button--danger {
						border: none !important;
					}

					/deep/.el-button {
						border: 1px solid #f44f4d !important;
						background: #f44f4d;
						color: #fff;
						border-radius: 0 4px 4px 0px;
					}
				}
			}

			.topsec {

				.kuai {
					display: flex;
					flex-wrap: wrap;

					span {
						margin-right: 20px;
						cursor: pointer;
					}

					span.onsele {
						color: #F44F4D;
					}
				}

				.el-form-item {
					display: flex;
				}
			}
		}

		// <div class="schmain">
		// 	<div class="sch-ul">
		// 		<div class="sch-li">
		// 			<div class="schli-l"><img src="../../assets/1.png" alt="" /></div>
		// 			<div class="schli-r">
		// 				<div class="schli-rt"><span class="schli-rt-a">天津大学</span><span class="schli-rt-b">dizhi</span></div>
		// 				<div class="schli-rb"><span>benke </span></div>
		// 			</div>
		// 		</div>
		// 	</div>
		// </div>
		.schmain {
			margin-top: 12px;

			.sch-ul {
				.schli-r-ll{
					cursor: pointer;
				}
				
				.schli-r-ll:hover {
					.schli-rt-a {
						color: #F44F4D;
					}
				}

				.sch-li {

					background: #fff;
					margin-bottom: 10px;
					display: flex;
					align-items: center;
					padding: 20px;
					border-radius: 10px;

					.schli-l {
						width: 60px;
						height: 60px;
						margin-right: 20px;

						img {
							width: 60px;
							height: 60px;
							border-radius: 50%;
						}
					}

					.schli-r {
						flex: 1;
						display: flex;
						.schli-r-ll{
							flex: 1;
							margin-right: 10px;
							.schli-rt {
								display: flex;
								align-items: center;
								margin-bottom: 10px;
							
								.schli-rt-a {
									font-size: 22px;
								}
							
								.schli-rt-b {
									// margin-left: 10px;
									// height: 25px;
									line-height: 18px;
									border-radius: 4px;
									border: 1px solid #d8d8d8;
									padding: 0 10px;
									font-size: 12px;
									color: #333;
									background: #f0f0f0;
								}
							}
							
							.schli-rb {
								margin-top: 6px;
							
								span:nth-child(1) {
									background: #f5f6f7;
								}
							
								span {
									height: 22px;
									padding: 0 8px;
									border-radius: 4px;
									font-size: 14px;
									color: #666;
									margin-right: 8px;
								}
							}
						}
						// <div class="schli-r-rr">
						// 	<table border="1" class="tableclass">
						// 	    <tr class="tableclass-tra">
						// 	        <th>专业代码</th>
						// 			<th>分数</th>
						// 	        <th>位次</th>
						// 	        <th>计划</th>
						// 	        <th>学费</th>
						// 	        <th>学制</th>
						// 	        <th>选科要求</th>
						// 	    </tr>
						// 	    <tr class="tableclass-trb">
						// 	        <td>张三</td>
						// 	        <td>28</td>
						// 	        <td>北京</td>
						// 	        <td>北京</td>
						// 	        <td>北京</td>
						// 	        <td>北京</td>
						// 	        <td>北京</td>
						// 	    </tr>
						// 	</table>
						// </div>
						.schli-r-rr{
							flex: 1;
							.tableclass{
								width: 100%;
								
								.tableclass-tra{
									font-size: 14px;
									th{
										text-align: center;
										padding: 4px 10px;
										border: 1px solid #d8d8d8;
										background-color: #F7F7F7;
									}
								}
								.tableclass-trb{
									font-size: 12px;
									td{
										text-align: center;
										padding: 10px;
										border-radius: 6px;
										border: 1px solid #d8d8d8;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.collboxA {
		display: flex;

		.collboxA-ul {
			.collboxA-ul-lisan {
				margin-right: 20px;
				cursor: pointer;
			}

			.collboxA-ul-lisan.onsele {
				color: #F44F4D;
			}
		}
	}
</style>